<template>
  <header :class="show?'':'notShow'">
    <div class="header-top">
      <div class="header-welcome">
        <div class="welcome-info">
          <p>Hello, welcome to Hangzhou YUANHUI Technology Co., Ltd.!</p>
          <hr />
        </div>
      </div>
      <div class="header-middle">
        <div class="header-logo"
            @click="goHome()">
          <img :src="colorStyle=='black'?whiteImg:blackImg"
             alt="">
        </div>
        <div class="header-slogan">
          HANGZHOU YUANHUI TECHNOLOGY CO.,LTD
          <!-- <span>YUANHUI Optoelectronics LED Display One-stop Service Center</span> -->
        </div>
        <div class="header-phone">
          Service Hotline
          <span>{{homePage.phone}}</span>
        </div>
      </div>
    </div>
    <div class="header-box">
      <ul @mouseenter="ulEnter()"
          @mouseleave="ulLeave()">
        <li v-for="(item,index) in navs">
          <div class="header-info"
               :class="colorStyle=='black'?'liBlack':''"
               :style="{color:colorStyle=='black'?'white':'black'}"
               @mouseenter="evtHeaderEnter(index)"
               @mouseleave="evtHeaderLeave(index)"
               @click="goClassify(item.id,item.name)">{{item.name}}</div>
          <el-collapse-transition>
            <div class="selectContext"
            v-if="item.children!=null"
                 v-show="index==itemIndex&&liStatus">
              <div class="selectItem"
                   v-for="(children,index2) in item.children"
                   @click="goShopping(children.id,children.name,item.id)">{{children.name}}</div>
            </div>
          </el-collapse-transition>
        </li>
        <div v-if="ulStatus"
             :style="{transform:'translate3d('+distance+'px, 0px, 0px)'}"
             class="navBar"></div>
      </ul>
      <!-- <div v-if="headerStatus"
           class="meanMask">

      </div> -->
      <!-- <div class="bgDiv"
           :class="colorStyle"></div> -->
    </div>
  </header>
</template>

<script>
import { getClassifyTree,getHomePage } from '../api/api'
export default {
  props: {
    colorStyle: {
      default: 'black'
    }
  },
  data () {
    return {
      navs: '',
      classifyList: '',
      itemIndex: 999,
      selectStatus: true,
      ulStatus: true,
      distance: 0,
      liStatus: true,
      blackImg: 'http://www.yuanwhite.com/app/img/static/logo.jpg',
      whiteImg: 'http://www.yuanwhite.com/app/img/static/logo.jpg',
      show: true,
      homePage:{}
    }
  },
  watch: {
    '$route' (to, from) {
      this.$router.go(0);
    }
  },
  methods: {
    ulEnter () {
      this.ulStatus = true;
      this.liStatus = true
    },
    ulLeave () {
      this.ulStatus = false;
      this.liStatus = false
    },
    evtHeaderEnter (index) {
      this.itemIndex = index;
      this.distance = 0;
      this.distance = this.distance + (index * 170)
    },
    evtHeaderLeave () { },
    //获取全部分类
    getClassify () {
      var that = this;
      getClassifyTree().then(res => {
        that.navs = res.data;
      })
    },
    //跳转去购物界面
    goClassify (id, name) {
      if(id==102){
        this.$router.push({ path: '/msgBoard', query: { classifyId: id, name: name } })
      }else{
        this.$router.push({ path: '/classify', query: { classifyId: id, name: name } })
      }
      this.headerStatus = false;
    },
    goShopping (id, name ,parentId) {
      if(parentId==1||parentId==104){
        this.$router.push({ path: '/info', query: { classifyId: id } })
      }else{
        this.$router.push({ path: '/shopping', query: { classifyId: id, name: name } })
      }
      this.headerStatus = false;
    },
    //跳转去详情页面
    goInfo (id) {
      this.$router.push({ path: '/info', query: { id: id } })
      this.headerStatus = false;
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    headerListen () {
      if (document.documentElement.scrollTop >= 500) {
        this.show = true
      } else {
        this.show = true
      }
    },
    getHomePage() {
      var that = this;
      getHomePage().then(res => {
        that.homePage = res.data;
      });
    }
  },
  mounted () {
    this.getClassify();
    this.getHomePage();
    //添加页面监听事件
    window.addEventListener("scroll", this.headerListen);
  },
}
</script>



// WEBPACK FOOTER //
// src/components/header-top.vue